export default {
  default: () => import("/codebuild/output/src4255038753/src/src/layouts/default.vue").then(m => m.default || m)
}